// Version : 0.0.1
// Author : VIGNESH
// LastEdit : VIGNESH
// Last ADD : REMOVED UNWANTED REDUX AND ADDED COMMENTS
// MODFIED DATA : 07-12-2025
import { docodeHexResponse } from '../../_common/common.utils';
import PortfolioReportTypes from './portfolio-report.type';

const INITIAL_STATE = {
	PortfolioReportResponse: null,
	PortfolioReportArr: [],
};

const portfolioReportReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************GET PORTFOLIO AT RISK START ************* */
		case PortfolioReportTypes.PORTFOLIO_REPORT_SUCCESS:
			return {
				...state,
				PortfolioReportResponse: action.payload,
				PortfolioReportArr: docodeHexResponse(action.payload, 'GetPortfolioReportKey'),
			};

		case PortfolioReportTypes.PORTFOLIO_REPORT_FAILURE:
			return { ...state, PortfolioReportResponse: action.payload };

		case PortfolioReportTypes.PORTFOLIO_REPORT_RESPONSE_CHANGED:
			return { ...state, PortfolioReportResponse: null };
		/** ***************GET PORTFOLIO AT RISK END ************* */
		default:
			return state;
	}
};

export default portfolioReportReducer;
